import { FormControl, MenuItem, Select }    from '@mui/material';
import React, { FC, useEffect,useState }    from 'react';
import { useNavigate }                       from 'react-router-dom';
import styled                               from 'styled-components';
import { queryParams }                      from '../../../../shared/functions';
import { UploadContactModal }               from '../../../../shared/components/modals/UploadContact/UploadContactModal';
import { UploadDocumentModal }              from '../../../../shared/components/modals/UploadDocument/UploadDocumentModal';
import { UploadEventModal }                 from '../../../../shared/components/modals/UploadEvent/UploadEventModal';
import { UploadTaskModal }                  from '../../../../shared/components/modals/UploadTask/UploadTaskModal';
import { EAppRoutes }                       from '../../../../shared/constants/constants';
import { documentTypes, documentTypesList } from '../../../../shared/documentTypes';
import { ButtonAdd }                        from './ButtonAdd';
import { LimitedModal }                     from '../../../../shared/components/modals/UploadTask/LimitedModal';
import { useFetchSchedulePage }             from '../../../Schedule/queries';
import { useFetchFamilies }                 from '../../../../shared/queries/family';

export const IconWrapper = styled.span`
  display: flex;
  margin-right: 10px;
`;

const DropdownWrapper = styled.div`
  flex: 1;
  display: flex;
  margin-right: 12px;
  width: 100%;
  max-width: 280px;
`;

const StyledDropdown = styled(FormControl)`
  flex: 1;
  width: 100%;
  
  .MuiSelect-outlined {
    background-color: #fff;
      display: flex !important; 
      align-items: center;
  }
  
  .MuiOutlinedInput-root {
    margin-top: 0;
      padding: 0 !important;
  }
`;

const FlexSection = styled.div`
  display: flex !important;
  flex-wrap: wrap;
  margin: 18px 0 12px;
  align-items: flex-end;
`;

interface IAddToFamilyCore {
  familyId?: string;
  familyMemberId?: string;
  isActivePayment?: boolean;
}

export const FlexibleSelect = styled(Select)<{ display?: string }>`&& {
  .MuiSelect-root {
    display: ${ ({ display }) => display || 'block' };

  };
}`;

export const AddToFamilyCore: FC<IAddToFamilyCore> = ({ familyId, familyMemberId, isActivePayment }) => {
  const history = useNavigate();
  const params = queryParams();
  const currentDate = new Date();
  const month = currentDate.getMonth() + 1;
  const year = currentDate.getFullYear();

  const [ uploadEventModalOpen, setUploadEventModalOpen ] = useState(false);
  const [ uploadContactModalOpen, setUploadContactModalOpen ] = useState(false);
  const [ uploadTaskModalOpen, setUploadTaskModalOpen ] = useState(false);
  const [ addDocumentModalOpen, setAddDocumentModalOpen ] = useState(false);

  // Lazy-mount flags: once a modal is opened for the first time it stays mounted
  // so keepMounted on the dialog keeps the form alive for instant subsequent opens.
  const [ docMounted, setDocMounted ]         = useState(false);
  const [ taskMounted, setTaskMounted ]       = useState(false);
  const [ contactMounted, setContactMounted ] = useState(false);
  const [ eventMounted, setEventMounted ]     = useState(false);
  const [ openFreeInfo, setOpenFreeInfo ] = useState(false);
  const [ addDocumentTo, setAddDocumentTo ] = useState(documentTypes.documents.name);

  const { data: schedule } = useFetchSchedulePage(familyId, params?.id, month, year);

  const { data: families } = useFetchFamilies();
  const [ eventsNumbersForUser, setEventsNumbersForUser ] = useState(0);

  const comparisonDate = new Date("2025-03-25T00:00:00+00:00");

  const foundFamily = families?.find(fam => fam.id === familyId);
  const foundFamilyCreatedAt = foundFamily?.createdAt ? new Date(foundFamily?.createdAt) : null;

  useEffect(() => {
    if (addDocumentTo === 'MaxEventNumber' || 'Events') {
      setEventsNumbersForUser(15);
    } else if (addDocumentTo === 'DocumentCategory' || 'Documents') {
      if (foundFamilyCreatedAt && foundFamilyCreatedAt > comparisonDate) {
        setEventsNumbersForUser(2);
      } else if (foundFamilyCreatedAt && foundFamilyCreatedAt < comparisonDate) {
        setEventsNumbersForUser(8);
      } else {
        setEventsNumbersForUser(2);
      }
    }
  }, [foundFamilyCreatedAt]);

  const onAdd = () => {
    if (addDocumentTo === documentTypes.documents.name) {
      setDocMounted(true);
      setAddDocumentModalOpen(true);
    } else if (addDocumentTo === documentTypes.tasks.name) {
      setTaskMounted(true);
      setUploadTaskModalOpen(true);
    } else if (addDocumentTo === documentTypes.contacts.name) {
      setContactMounted(true);
      setUploadContactModalOpen(true);
    } else if (addDocumentTo === documentTypes.events.name) {
      if ( schedule !== undefined && schedule.totalCount === 15 && !isActivePayment) {
        setOpenFreeInfo(true);
      } else {
        setEventMounted(true);
        setUploadEventModalOpen(true);
      }
    } else if (addDocumentTo === documentTypes.checkIns.name) {
      history(EAppRoutes.Locate);
    }
  };

  return (
    <>
      <FlexSection>
        <DropdownWrapper>
          <StyledDropdown variant="outlined">
            <FlexibleSelect
              displayEmpty
              value={addDocumentTo}
              display="flex"
              onChange={(event: any) => setAddDocumentTo(event.target.value)}
            >
              { documentTypesList.map((item, index) => (
                <MenuItem
                  key={index + 1}
                  value={item.name}
                >
                  <IconWrapper>
                    { item.icon }
                  </IconWrapper>

                  { item.name }
                </MenuItem>
              )) }
            </FlexibleSelect>
          </StyledDropdown>
        </DropdownWrapper>

        <ButtonAdd onClick={() => onAdd()} />
      </FlexSection>

      { docMounted && (
        <UploadDocumentModal
          familyId={familyId}
          familyUserId={familyMemberId}
          open={addDocumentModalOpen}
          onClose={() => setAddDocumentModalOpen(false)}
        />
      ) }

      { taskMounted && (
        <UploadTaskModal
          familyId={familyId}
          open={uploadTaskModalOpen}
          onClose={() => setUploadTaskModalOpen(false)}
        />
      ) }

      { contactMounted && (
        <UploadContactModal
          familyId={familyId}
          open={uploadContactModalOpen}
          onClose={() => setUploadContactModalOpen(false)}
        />
      ) }

      { eventMounted && (
        <UploadEventModal
          familyId={familyId}
          open={uploadEventModalOpen}
          onClose={() => setUploadEventModalOpen(false)}
        />
      ) }

      <LimitedModal
        openFreeInfo={openFreeInfo}
        entityName={addDocumentTo}
        eventsNumbersForUser={eventsNumbersForUser}
        setOpenFreeInfo={setOpenFreeInfo}
      />
    </>
  );
};
